import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export default function Gala2024Page() {
  const { locale, prefix } = useLanguage();
  const isZh = locale === 'zh';

  return (
    <div>
      {/* Hero */}
      <section
        style={{
          background: 'linear-gradient(135deg, #b71c1c 0%, #c62828 40%, #e53935 100%)',
          color: '#fff',
          padding: '120px 0 80px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle at 25% 45%, rgba(255,215,0,0.15) 0%, transparent 50%), radial-gradient(circle at 75% 55%, rgba(255,152,0,0.1) 0%, transparent 50%)',
          }}
        />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span
            style={{
              display: 'inline-block',
              background: 'rgba(255,255,255,0.15)',
              backdropFilter: 'blur(8px)',
              borderRadius: 24,
              padding: '6px 20px',
              fontSize: '0.85rem',
              fontWeight: 600,
              marginBottom: 20,
              letterSpacing: 1,
            }}
          >
            {isZh ? '2024 龙年' : '2024 YEAR OF THE DRAGON'}
          </span>
          <h1 style={{ fontSize: '3.5rem', fontWeight: 900, marginBottom: 12, lineHeight: 1.1 }}>
            {isZh ? '《盛宴》2024' : 'Festive Feast 2024'}
          </h1>
          <p style={{ fontSize: '1.5rem', fontWeight: 300, marginBottom: 8, opacity: 0.95 }}>
            {isZh ? '橙县华人龙年春晚' : 'Year of the Dragon Lunar New Year Gala'}
          </p>
          <p style={{ fontSize: '1.1rem', opacity: 0.85, maxWidth: 600, margin: '0 auto 32px' }}>
            {isZh
              ? 'Chinese-American Association of Orange County'
              : '橙县华人协会 (CAAOC)'}
          </p>
          <span
            className="badge"
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: '#fff',
              fontSize: '0.9rem',
              padding: '8px 20px',
            }}
          >
            {isZh ? '已圆满结束' : 'Event Concluded'}
          </span>
        </div>
      </section>

      {/* Event Details */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'start' }}>
            <div>
              <h2 className="section-title" style={{ marginBottom: 24 }}>
                {isZh ? '活动详情' : 'Event Details'}
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                {[
                  {
                    icon: '\uD83D\uDCC5',
                    label: isZh ? '日期' : 'Date',
                    value: isZh ? '2024年2月3日 (星期六)' : 'Saturday, February 3, 2024',
                  },
                  {
                    icon: '\u23F0',
                    label: isZh ? '时间' : 'Time',
                    value: isZh ? '7:00pm 演出' : '7:00 PM Performance',
                  },
                  {
                    icon: '\uD83D\uDCCD',
                    label: isZh ? '地点' : 'Venue',
                    value: 'Irvine Barclay Theatre, 4242 Campus Dr, Irvine, CA 92612',
                  },
                  {
                    icon: '\uD83D\uDC09',
                    label: isZh ? '主题' : 'Theme',
                    value: isZh ? '龙年庆典 - 龙腾盛世' : 'Year of the Dragon - Rising Dragon',
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      display: 'flex',
                      gap: 16,
                      alignItems: 'flex-start',
                      padding: 16,
                      background: 'var(--gray-100)',
                      borderRadius: 'var(--radius-md)',
                    }}
                  >
                    <span style={{ fontSize: '1.5rem', flexShrink: 0 }}>{item.icon}</span>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>
                        {item.label}
                      </div>
                      <div style={{ fontWeight: 600, color: 'var(--gray-800)', fontSize: '1rem' }}>
                        {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Ticket Info (historical) */}
              <div
                style={{
                  marginTop: 24,
                  padding: 20,
                  background: 'var(--yellow-bg)',
                  borderRadius: 'var(--radius-md)',
                  borderLeft: '4px solid var(--yellow-accent)',
                }}
              >
                <div style={{ fontWeight: 700, color: 'var(--yellow-accent)', marginBottom: 8 }}>
                  {isZh ? '购票信息（已结束）' : 'Ticket Info (Event Concluded)'}
                </div>
                <p style={{ fontSize: '0.9rem', color: 'var(--gray-600)', lineHeight: 1.6 }}>
                  {isZh
                    ? '个人购票曾通过Ovationtix平台进行。团体票及赞助咨询电话：(949) 351-7357, (949) 266-7858'
                    : 'Individual tickets were available through the Ovationtix platform. Group sales & sponsorship inquiries: (949) 351-7357, (949) 266-7858'}
                </p>
              </div>
            </div>

            <div>
              <h2 className="section-title" style={{ marginBottom: 24 }}>
                {isZh ? '关于2024春晚' : 'About the 2024 Gala'}
              </h2>
              <div style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8 }}>
                <p style={{ marginBottom: 16 }}>
                  {isZh
                    ? '华人春晚，是每一个远离故土的华人心中最温暖的乡愁。在海外举办华人春晚，不仅是一场文艺演出，更是华人文化传承和社区凝聚力的体现。橙县华人春晚自创办以来，从一个小型社区活动发展成为南加州最受瞩目的华人文化盛事之一。'
                    : 'The Chinese Spring Gala holds a deeply emotional significance for every Chinese person living away from their homeland. Hosting a Spring Gala overseas is not just an artistic performance — it represents the inheritance of Chinese culture and the cohesion of our community. Since its founding, the Orange County Chinese Spring Gala has grown from a small community event into one of the most celebrated Chinese cultural events in Southern California.'}
                </p>
                <p style={{ marginBottom: 16 }}>
                  {isZh
                    ? '2024龙年春晚以"龙腾盛世"为主题，汇集了橙县华人社区最优秀的文艺人才。整台演出精心策划，涵盖声乐、舞蹈、器乐、武术等多种艺术形式，为观众带来了一场视听盛宴。'
                    : 'The 2024 Year of the Dragon Gala was themed "Rising Dragon" and brought together the finest artistic talent from the Orange County Chinese-American community. The carefully curated show featured vocal performances, dance, instrumental music, martial arts, and more, creating a spectacular audiovisual feast for the audience.'}
                </p>
                <p>
                  {isZh
                    ? '龙年春晚的成功举办，离不开协会团队的辛勤付出、众多志愿者的无私奉献，以及社区各界人士的大力支持。'
                    : 'The success of the Dragon Year Gala was made possible by the hard work of the association team, the selfless dedication of numerous volunteers, and the generous support of community members.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 className="section-title">{isZh ? '演出视频' : 'Performance Video'}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              {isZh ? '观看2024龙年春晚精彩回放' : 'Watch the 2024 Year of the Dragon Gala replay'}
            </p>
          </div>

          <div
            style={{
              maxWidth: 800,
              margin: '0 auto',
              background: 'var(--white)',
              borderRadius: 'var(--radius-lg)',
              overflow: 'hidden',
              boxShadow: 'var(--shadow-xl)',
            }}
          >
            <div
              style={{
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                background: '#000',
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/videoseries?list=PLExample2024"
                title="Festive Feast 2024"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Historical Context */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            <h2 className="section-title" style={{ textAlign: 'center', marginBottom: 24 }}>
              {isZh ? '协会历程' : 'Our Journey'}
            </h2>
            <div style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8, textAlign: 'center' }}>
              <p style={{ marginBottom: 16 }}>
                {isZh
                  ? '从2012年的初创，到疫情前的蓬勃发展，再到疫情后的重新出发，橙县华人协会始终与社区同行。每一届春晚都记录着我们的成长与坚持。'
                  : 'From our founding in 2012 to the vibrant growth before the pandemic, and our resilient restart afterward, CAAOC has always walked alongside the community. Each Gala marks a chapter of our growth and perseverance.'}
              </p>
              <p>
                {isZh
                  ? '龙年春晚标志着疫情后协会活动的全面恢复，也开启了新的篇章。感谢每一位支持者，让我们的社区更加紧密团结。'
                  : 'The Year of the Dragon Gala marked the full recovery of our activities after the pandemic and the beginning of a new chapter. Thank you to every supporter for making our community stronger and more united.'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation to other galas */}
      <section style={{ padding: '48px 0 64px', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
            <Link to={prefix + '/gala'} className="btn btn-primary" style={{ padding: '12px 28px' }}>
              {isZh ? '《盛宴》2026' : 'Festive Feast 2026'}
            </Link>
            <Link to={prefix + '/gala/2025'} className="btn btn-outline" style={{ padding: '12px 28px' }}>
              {isZh ? '《盛宴》2025' : 'Festive Feast 2025'}
            </Link>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .section-title { font-size: 1.8rem !important; }
        }
      `}</style>
    </div>
  );
}
